import { __assign, __read, __rest, __spread } from "tslib";
import { convertDate } from '@keen.io/time-utils';
import { KEEN_KEY, KEEN_VALUE } from '../../constants';
export var transformChronologicalCategoricalNominal = function (_a, _b) {
    var result = _a.result;
    var dateModifier = _b.dateModifier;
    var data = [];
    var keys = new Set();
    keys.add(KEEN_VALUE);
    result.map(function (interval) {
        var _a;
        var _b = interval, start = _b.timeframe.start, value = _b.value;
        var record = (_a = {},
            _a[KEEN_KEY] = convertDate(start, dateModifier),
            _a);
        value.forEach(function (_a) {
            var _b;
            var result = _a.result, properties = __rest(_a, ["result"]);
            data.push(__assign(__assign(__assign({}, record), properties), (_b = {}, _b[KEEN_VALUE] = result, _b)));
            Object.keys(properties).forEach(function (propertyName) { return keys.add(propertyName); });
        });
    });
    return {
        data: data,
        keys: __spread(keys),
    };
};
